// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"63547506","74":"1d84adfe","161":"d147d2e9","376":"45f3b248","462":"83171435","466":"846a3b78","471":"ad0a9188","821":"a1d8d5b8","891":"c180897b","949":"deb62ea8"}[chunkId] + ".chunk.js";
};